export default  [
    {
        id: 0,
        nombre: "OK",
        descripcion: "La consulta http tuvo respuesta satisfactoria."
    },
    {
        id: 8,
        nombre: "OK",
        descripcion: "OK al segundo intento"
    },
    {
        id: 9,
        nombre: "DNS OK No autoritativo",
        descripcion: "La respuesta del DNS no es autoritativa, es decir, la respuesta proviene de tablas temporales (cache) de un DNS no oficial del dominio."
    },
    {
        id: 14,
        nombre: "DNS OK autoritativo",
        descripcion: "DNS Ok Autoritativo"
    },
    {
        id: 17,
        nombre: "Servidor Correo OK",
        descripcion: "Fue posible obtener conexión con el servidor de correo."
    },
    {
        id: 25,
        nombre: "Faltaron Elementos",
        descripcion: "Faltaron Elementos por Descargar"
    },
    {
        id: 26,
        nombre: "Terminado con errores",
        descripcion: "Existieron errores en el monitoreo, pero pueden no ser de importancia"
    },
    {
        id: 30,
        nombre: "Mail OK",
        descripcion: "Mail Recibido OK"
    },
    {
        id: 200,
        nombre: "OK",
        descripcion: "OK"
    },
    {
        id: 204,
        nombre: "No Content",
        descripcion: "No Content"
    },
    {
        id: 301,
        nombre: "Redirección Permanente",
        descripcion: "Redirección Permanente"
    },
    {
        id: 302,
        nombre: "Redireccionado",
        descripcion: "Redireccionado"
    },
    {
        id: 304,
        nombre: "Not Modified",
        descripcion: "Not Modified"
    },
    {
        id: 307,
        nombre: "Movido Temporalmente",
        descripcion: "Movido Temporalmente"
    },
    {
        id: 602,
        nombre: "Operador contestó",
        descripcion: "EL operador atendió la llamada"
    },
    {
        id: 1000,
        nombre: "Elemento excluído",
        descripcion: "Elemento excluído"
    },
]